import React from 'react';

import WhiteboardObjectTile from '@atlaskit/object/tile/whiteboard';

export default function ObjectTileDefault(): React.JSX.Element {
	return <WhiteboardObjectTile />;
}
